import flatpickr from "flatpickr";

(function () {
  const datepickerEl = document.getElementById('datepicker');
  if (datepickerEl) {
   flatpickr('#datepicker', {
      inline: true,
      minDate: "today",
      dateFormat: "n/j/Y", 
      disable: [
        function (date) {
          return (date.getDay() === 0 || date.getDay() === 6);
        }
      ],
      locale: {
        "firstDayOfWeek": 1
      },
      minuteIncrement: 1,

     onChange: (selectedDates, dateStr, instance) => {
       document.querySelector("[name=meeting_date]").value = dateStr + " " + "12:00 PM";
     },
     });
  }
})();
